import { MOKA_ACCOUNT_API } from 'api/constants';

export const ROLES = `${MOKA_ACCOUNT_API}/v1/roles?deep=true`;

export const CREATE_ROLE = `${MOKA_ACCOUNT_API}/v1/roles`;

export const UPDATE_ROLE = roleId => {
  return `${MOKA_ACCOUNT_API}/v1/roles/${roleId}`;
};

export const DELETE_ROLE = roleId => {
  return `${MOKA_ACCOUNT_API}/v1/roles/${roleId}`;
};
